import { Button } from "@chakra-ui/react";

import { useAppModal } from "../../Modals";
import { AddCardModal } from "./AddCardModal.tsx";

interface Props {
  isProductStatusChanging?: boolean;
}

export function AddCardButton({ isProductStatusChanging = false }: Props) {
  const { showModal, hideModal } = useAppModal();

  const onClick = () => {
    showModal({
      header: "Добавить способ оплаты",
      content: () => <AddCardModal hideModal={hideModal} />,
    });
  };

  return (
    <Button
      w="100%"
      onClick={onClick}
      colorScheme="brand"
      isDisabled={isProductStatusChanging}
    >
      Добавить способ оплаты
    </Button>
  );
}
